// extracted by mini-css-extract-plugin
export default {"video":"Showreel_video__eYhXx","reel":"Showreel_reel__tvU7p","wrapper":"Showreel_wrapper__Wwv7k","title":"Showreel_title__I0Ea+"};